import React from 'react';
import { Helmet } from 'react-helmet-async';
import MainLayout from '../layouts/MainLayout';
import { QuestionCircleOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const FAQ = () => {
    const faqCategories = [
        {
            category: 'Lastik Seçimi',
            icon: '🚗',
            questions: [
                {
                    question: 'Aracım için hangi lastik boyutunu seçmeliyim?',
                    answer: 'Aracınızın lastik boyutu, araç ruhsatınızda veya sürücü kapısı çerçevesindeki etikette belirtilmiştir. Örnek: 205/55 R16. İlk rakam genişlik (mm), ikinci rakam yükseklik/genişlik oranı (%), R radyal yapı ve son rakam jant çapıdır (inç). Farklı boyut kullanımı araç güvenliğini ve yakıt tüketimini olumsuz etkiler.'
                },
                {
                    question: 'Kış lastiği ne zaman takmalıyım?',
                    answer: 'Hava sıcaklığı 7°C\'nin altına düştüğünde kış lastiğine geçmeniz önerilir. Genellikle Ekim-Kasım aylarında kış lastiğine, Nisan-Mayıs aylarında yaz lastiğine geçiş yapılır. Kış lastikleri düşük sıcaklıklarda daha iyi performans gösterir ve kar, buz gibi zorlu koşullarda güvenli sürüş sağlar.'
                },
                {
                    question: 'Run-flat (yol tutucu) lastik nedir?',
                    answer: 'Run-flat lastikler, patladıktan sonra bile belirli bir mesafe (genellikle 80 km) ve hızda (80 km/h) sürüş yapabilmenizi sağlayan özel yapılı lastiklerdir. Yan duvarları güçlendirilmiştir. Yedek lastik taşımak istemeyenler için idealdir, ancak sürüş konforu normal lastiklere göre daha serttir.'
                },
                {
                    question: 'Lastik yük ve hız indeksi nedir?',
                    answer: 'Yük indeksi (Load Index), lastiğin taşıyabileceği maksimum ağırlığı gösterir (örn: 91 = 615 kg). Hız indeksi (Speed Rating) ise lastiğin güvenle ulaşabileceği maksimum hızı belirtir (örn: H = 210 km/h, V = 240 km/h). Araç ruhsatınızdaki değerlere eşit veya daha yüksek indeksli lastik kullanmalısınız.'
                }
            ]
        },
        {
            category: 'Lastik Bakımı',
            icon: '🔧',
            questions: [
                {
                    question: 'Lastik hava basıncını ne sıklıkla kontrol etmeliyim?',
                    answer: 'Lastik hava basıncını ayda en az 1 kez ve uzun yolculuk öncesi mutlaka kontrol etmelisiniz. Basınç kontrolü lastikler soğukken yapılmalıdır. Düşük basınç yakıt tüketimini artırır, lastik ömrünü kısaltır ve yol tutuşunu bozar. Yüksek basınç ise sürüş konforunu azaltır ve lastik aşınmasını hızlandırır.'
                },
                {
                    question: 'Lastiklerin ömrü ne kadardır?',
                    answer: 'Lastik ömrü kullanım koşullarına göre değişir ancak genel olarak 5-6 yıl veya 40.000-60.000 km arasındadır. Lastik yan duvarındaki DOT kodundan üretim tarihini öğrenebilirsiniz (örn: DOT 2321 = 2023 yılının 23. haftası). 10 yıldan eski lastikler görünümü iyi olsa bile değiştirilmelidir.'
                },
                {
                    question: 'Lastik desen derinliği ne olmalıdır?',
                    answer: 'Yasal minimum desen derinliği 1.6 mm\'dir ancak güvenli sürüş için yaz lastiklerinde 3 mm, kış lastiklerinde 4 mm\'nin altına düştüğünde değiştirilmesi önerilir. Desen derinliğini ölçmek için özel ölçüm cihazları kullanılır veya lastiklerdeki aşınma gösterge çubuklarından kontrol edilebilir.'
                },
                {
                    question: 'Lastik rotasyonu nedir, neden yapılmalıdır?',
                    answer: 'Lastik rotasyonu, lastiklerin konumlarının değiştirilerek düzgün aşınmasını sağlayan bir işlemdir. 10.000-15.000 km\'de bir yapılması önerilir. Ön ve arka lastikler farklı oranlarda aşındığı için rotasyon lastik ömrünü uzatır ve tüm lastiklerin aynı anda değiştirilmesini sağlar.'
                }
            ]
        },
        {
            category: 'Elektrikli Araç Lastikleri',
            icon: '⚡',
            questions: [
                {
                    question: 'Elektrikli araçlar için özel lastik gerekli mi?',
                    answer: 'Evet, elektrikli araçlar için özel tasarlanmış lastikler kullanılması önerilir. Elektrikli araçlar daha ağırdır (batarya nedeniyle) ve yüksek torklu anında ivmelenme yapabilirler. EV lastikleri daha yüksek yük taşıma kapasitesine, düşük yuvarlanma direncine (menzil için) ve sessiz yapıya sahiptir. Örnekler: Michelin e-Primacy, Continental EcoContact 6.'
                },
                {
                    question: 'Elektrikli araç lastikleri normal lastiklerden nasıl farklıdır?',
                    answer: 'EV lastikleri şu özelliklere sahiptir: 1) Güçlendirilmiş yapı (ağırlık için), 2) Düşük yuvarlanma direnci (enerji tasarrufu, daha uzun menzil), 3) Sessiz sırtlık yapısı (motor sesi olmadığı için yol gürültüsü daha belirgin), 4) Yüksek tork dayanımı (hızlı ivmelenme), 5) Gelişmiş kavrama (güvenlik).'
                },
                {
                    question: 'Elektrikli araçlarda lastik ömrü daha mı kısa?',
                    answer: 'Elektrikli araçların lastikleri, yüksek tork ve ağır yapı nedeniyle geleneksel araçlara göre %20-30 daha hızlı aşınabilir. Ancak EV\'ye özel lastik kullanımı, düzgün bakım ve yumuşak sürüş tarzı ile bu etki azaltılabilir. Özellikle ön lastikler daha çabuk aşınır (çoğu EV ön tekerlekten çeker).'
                },
                {
                    question: 'Tesla, BMW i3 gibi elektrikli araçlar için lastik önerileriniz nedir?',
                    answer: 'Tesla Model 3/Y için: Michelin Pilot Sport EV, Continental EcoContact 6, Pirelli P Zero Elect. BMW i3 için: Bridgestone Ecopia EP500, Hankook Kinergy 4S2. Mercedes EQC için: Goodyear EfficientGrip Performance, Michelin e-Primacy. Her zaman OEM (orijinal ekipman) onaylı lastik kullanmanız önerilir.'
                }
            ]
        },
        {
            category: 'Lastik Tamiri ve Değişim',
            icon: '🛠️',
            questions: [
                {
                    question: 'Her lastik tamiri yapılabilir mi?',
                    answer: 'Hayır, sadece lastik sırtında (temas yüzeyinde) 6 mm\'den küçük delikler tamir edilebilir. Yan duvarda, omuzda veya dış kenar bölgesindeki hasar, 6 mm\'den büyük delikler ve birden fazla tamir görmüş lastikler güvenli değildir. Tamir sonrası lastiğin hız ve yük sınırlaması olabilir.'
                },
                {
                    question: 'Lastik patladığında ne yapmalıyım?',
                    answer: '1) Panik yapmayın, direksiyonu sıkı tutun. 2) Ani fren yapmayın, gazdan yavaşça ayağınızı çekin. 3) Acil ikaz lambalarını yakın. 4) Güvenli bir yere park edin (mümkünse yol kenarı). 5) Yedek lastik takın veya yol yardım çağırın. 6) Reflektörlü yelek giyin, üçgen reflektör yerleştirin.'
                },
                {
                    question: 'Lastikleri ikili değiştirmeli miyim?',
                    answer: 'Evet, güvenlik ve performans için lastikler ikili (aynı aks üzerindeki iki lastik) değiştirilmelidir. İdeal olan dördünü birden değiştirmektir. Tek lastik değişiminde, yeni lastik arka aksa takılmalı ve tüm lastiklerin markası, modeli ve desen yapısı aynı olmalıdır. Desen derinliği farkı 4 mm\'yi geçmemelidir.'
                },
                {
                    question: 'Ikinci el lastik alabilir miyim?',
                    answer: 'İkinci el lastik almak önerilmez. Lastiğin geçmişi (kaza, hasar, tamir) bilinmez ve iç yapı hasarları gözle görülmez. Ayrıca hatalı depolama lastiğe zarar verir. Eğer ikinci el alacaksanız: 1) Üretim tarihini kontrol edin (3 yıldan eski olmasın), 2) Yan duvar çatlakları araştırın, 3) Desen derinliği min. 4 mm olsun, 4) Eşit aşınma olduğundan emin olun.'
                }
            ]
        },
        {
            category: 'Genel Sorular',
            icon: '❓',
            questions: [
                {
                    question: 'Yazlık lastikle kışın gidebilir miyim?',
                    answer: 'Hukuki olarak yasak değil ancak güvenlik riski vardır. Yaz lastikleri 7°C altında sertleşir, kavrama ve fren mesafesi artar. Kar, buz gibi koşullarda tehlikeli olabilir. Kışın yaz lastiği kullanımı sigortadan sorumluluk reddine yol açabilir. Özellikle dağlık bölgelerde kış lastiği zorunludur.'
                },
                {
                    question: 'Lastik garantisi var mıdır?',
                    answer: 'Evet, lastikler üretim kusurlarına karşı genellikle 5 yıl garantilidir. Garanti kapsamına: üretim hatası, kabarcık, malzeme kusuru girer. Kapsam dışı: normal aşınma, hasar (çivi, darbe), hatalı kullanım, yetersiz bakım. Garanti için fatura, lastik DOT kodu ve hasar fotoğrafları gereklidir.'
                },
                {
                    question: 'Yedek lastiğimi ne sıklıkla kontrol etmeliyim?',
                    answer: 'Yedek lastiği 3 ayda bir kontrol etmelisiniz: 1) Hava basıncı (genellikle normal basıncın üstünde şişirilir), 2) Görünür hasar, çatlak, 3) Desen derinliği, 4) Yaş (DOT kodu). Acil yedek lastikler (slim fit) sadece geçici kullanım içindir, maksimum 80 km/h ve 100 km mesafe ile sınırlıdır.'
                },
                {
                    question: 'Lastik fiyatları neden farklılık gösterir?',
                    answer: 'Lastik fiyatları şu faktörlere bağlıdır: 1) Marka (premium: Michelin, Bridgestone vs budget: Lassa), 2) Teknoloji (run-flat, ses azaltma, yuvarlanma direnci), 3) Mevsim (kış lastikleri daha pahalı), 4) Boyut (büyük boyutlar daha pahalı), 5) Üretim yılı ve stok durumu. Premium lastikler daha uzun ömürlü ve güvenlidir.'
                }
            ]
        }
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Sıkça Sorulan Sorular - Sakarya Lastik | Lastik Bakım ve Tavsiyeler</title>
                <meta name="description" content="Lastik seçimi, bakımı, elektrikli araç lastikleri, tamir ve değişim hakkında merak ettikleriniz. Uzman tavsiyeleri ve detaylı cevaplar." />
                <meta name="keywords" content="lastik sss, lastik bakımı, elektrikli araç lastiği, lastik seçimi, kış lastiği, lastik tamiri" />
            </Helmet>

            {/* Hero Section */}
            <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white py-16">
                <div className="container mx-auto px-4">
                    <div className="flex items-center mb-4">
                        <QuestionCircleOutlined className="text-5xl mr-4" />
                        <div>
                            <h1 className="text-4xl md:text-5xl font-bold">Sıkça Sorulan Sorular</h1>
                            <p className="text-xl text-orange-100 mt-2">
                                Lastikler hakkında merak ettiğiniz her şey burada!
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* FAQ Content */}
            <div className="container mx-auto px-4 py-12">
                <div className="max-w-5xl mx-auto">
                    <div className="bg-orange-50 rounded-lg p-6 mb-8 text-center">
                        <p className="text-gray-700">
                            Aradığınız soruyu bulamadınız mı?
                            <a href="/iletisim" className="text-orange-600 font-bold ml-2 hover:underline">
                                Bize Ulaşın →
                            </a>
                        </p>
                    </div>

                    {faqCategories.map((category, categoryIndex) => (
                        <div key={categoryIndex} className="mb-8">
                            <div className="flex items-center mb-4">
                                <span className="text-4xl mr-3">{category.icon}</span>
                                <h2 className="text-2xl font-bold text-gray-800">{category.category}</h2>
                            </div>

                            <Collapse
                                accordion
                                expandIcon={({ isActive }) =>
                                    isActive ? <MinusOutlined /> : <PlusOutlined />
                                }
                                className="bg-white shadow-md"
                            >
                                {category.questions.map((item, index) => (
                                    <Panel
                                        header={
                                            <span className="font-semibold text-gray-800">
                                                {item.question}
                                            </span>
                                        }
                                        key={index}
                                        className="border-b last:border-b-0"
                                    >
                                        <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                                            {item.answer}
                                        </p>
                                    </Panel>
                                ))}
                            </Collapse>
                        </div>
                    ))}
                </div>

                {/* CTA Section */}
                <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-lg p-12 text-center mt-12">
                    <h2 className="text-3xl font-bold mb-4">Hala Sorunuz mu Var?</h2>
                    <p className="text-xl text-gray-300 mb-6 max-w-2xl mx-auto">
                        Uzman ekibimiz size yardımcı olmaktan mutluluk duyar. Bizi arayın veya mağazamızı ziyaret edin.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="tel:+905441205454"
                            className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
                        >
                            📞 0544 120 54 54
                        </a>
                        <a
                            href="/iletisim"
                            className="bg-white text-gray-800 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors"
                        >
                            📧 İletişim Formu
                        </a>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default FAQ;
